
import * as z from "zod";

export const worksheetFormSchema = z.object({
  name: z.string().min(1, "ชื่อชีทเป็นข้อมูลที่จำเป็น"),
  subject: z.string().min(1, "วิชาเป็นข้อมูลที่จำเป็น"),
  grade_level: z.string().min(1, "ระดับชั้นเป็นข้อมูลที่จำเป็น"),
  semester: z.string().optional(),
  fs_name: z.string().optional(),
  document_urls: z.union([
    z.string().optional(),
    z.array(z.string()).optional()
  ]).transform(val => {
    if (typeof val === 'string') {
      return val ? val.split('\n').map(url => url.trim()).filter(url => url !== '') : [];
    }
    return val || [];
  }),
  status: z.string().optional()
});

export type WorksheetFormValues = z.infer<typeof worksheetFormSchema>;
